import { apiClient } from './client';

export interface ReferralCodeResponse {
  referralCode: string;
  shareUrl: string;
}

export interface ReferralStats {
  totalReferrals: number;
  successfulReferrals: number;
  pendingReferrals: number;
  qualifiedReferrals: number;  // Friends who spent >= $2
  totalRewardsEarned: number;
}

export interface ValidateReferralResponse {
  valid: boolean;
  referrer?: {
    nickname: string;
  };
}

export const referralsAPI = {
  /**
   * Get or create user's referral code
   */
  getReferralCode: async (): Promise<ReferralCodeResponse> => {
    const response = await apiClient.get('/api/referrals/code');
    return response.data;
  },

  /**
   * Get user's referral statistics
   */
  getReferralStats: async (): Promise<ReferralStats> => {
    const response = await apiClient.get('/api/referrals/stats');
    return response.data.stats;
  },

  /**
   * Validate a referral code (used during registration)
   */
  validateReferralCode: async (referralCode: string): Promise<ValidateReferralResponse> => {
    const response = await apiClient.post('/api/referrals/validate', { referralCode });
    return response.data;
  }
};
